import React from 'react'
import MarketingMangerTC from '../../features/marketingManager/MarketingMangerTC'

const MarketingMangerTCPage = () => {
  return (
    <MarketingMangerTC/>
  )
}

export default MarketingMangerTCPage